var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "11", xl: "10" } },
            [
              !_vm.isUserAdmin
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-8",
                      attrs: { type: "error", outlined: "" },
                    },
                    [
                      _vm._v(
                        " You are not allowed to access SMT Admin Consent. "
                      ),
                    ]
                  )
                : _c(
                    "v-card",
                    {
                      staticClass: "mt-8 mb-8 smt-card",
                      attrs: { loading: _vm.loading },
                    },
                    [
                      _c(
                        "template",
                        { slot: "progress" },
                        [
                          _c("v-progress-linear", {
                            attrs: {
                              color: "#006c27",
                              indeterminate: "",
                              height: "6",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-title",
                        {
                          staticClass: "grey--text text--darken-2 smt-toolbar",
                        },
                        [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "text-h6 font-weight-bold" },
                              [_vm._v("SMT Admin Consent")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-caption grey--text text--darken-1 mt-1",
                              },
                              [
                                _vm._v(
                                  " Showing " +
                                    _vm._s(_vm.filteredRows.length) +
                                    " of " +
                                    _vm._s(_vm.rows.length) +
                                    " proxies | Export AppIDs: " +
                                    _vm._s(_vm.filteredMappedClientIdsCount) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                text: "",
                                color: "#006c27",
                                loading:
                                  _vm.loading &&
                                  _vm.activeLoadAction === "reload",
                                disabled: _vm.loading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.loadData(false, "reload")
                                },
                              },
                            },
                            [_vm._v(" Reload ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                color: "#006c27",
                                dark: "",
                                loading:
                                  _vm.loading &&
                                  _vm.activeLoadAction === "force",
                                disabled: _vm.loading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.loadData(true, "force")
                                },
                              },
                            },
                            [_vm._v(" Force Refresh ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: { outlined: "", color: "#006c27" },
                              on: {
                                click: function ($event) {
                                  _vm.statsDialog = true
                                },
                              },
                            },
                            [_vm._v(" Stats ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                outlined: "",
                                color: "#006c27",
                                disabled:
                                  _vm.filteredRows.length === 0 || _vm.loading,
                              },
                              on: { click: _vm.downloadCsv },
                            },
                            [_vm._v(" Download CSV ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "div",
                            { staticClass: "text-caption grey--text mb-3" },
                            [
                              _vm._v(
                                " Cache refreshed: " +
                                  _vm._s(
                                    _vm.formatDate(_vm.cache.refreshedAt)
                                  ) +
                                  " | cache hit: " +
                                  _vm._s(_vm.cache.cacheHit ? "yes" : "no") +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "v-row",
                            { staticClass: "mb-2", attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "8" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      clearable: "",
                                      "prepend-inner-icon": "mdi-magnify",
                                      label:
                                        "Search proxy, base path, URI, clientId, servicePrincipalId, lookup error",
                                    },
                                    model: {
                                      value: _vm.searchQuery,
                                      callback: function ($$v) {
                                        _vm.searchQuery = $$v
                                      },
                                      expression: "searchQuery",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.filterPresets,
                                      "item-text": "text",
                                      "item-value": "value",
                                      outlined: "",
                                      dense: "",
                                      label: "Filter preset",
                                    },
                                    model: {
                                      value: _vm.activePreset,
                                      callback: function ($$v) {
                                        _vm.activePreset = $$v
                                      },
                                      expression: "activePreset",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "mb-3" },
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    small: "",
                                    color: "#e8f5e9",
                                    "text-color": "#1b5e20",
                                  },
                                },
                                [
                                  _vm._v(
                                    " Unmapped in view: " +
                                      _vm._s(_vm.filteredUnmappedRowsCount) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    small: "",
                                    color: "#e3f2fd",
                                    "text-color": "#0d47a1",
                                  },
                                },
                                [
                                  _vm._v(
                                    " Fully mapped in view: " +
                                      _vm._s(_vm.filteredFullyMappedRowsCount) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-data-table",
                            {
                              staticClass: "elevation-1 smt-table",
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.filteredRows,
                                "items-per-page": 15,
                                "item-key": "rowKey",
                                "item-class": _vm.rowClass,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: `item.proxy`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-caption proxy-cell",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "proxy-name" },
                                              [_vm._v(_vm._s(item.proxyName))]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "proxy-path" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.basePath || "-")
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.dev`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-caption env-cell",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "env-row" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "env-key" },
                                                  [_vm._v("URI")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "env-value mono",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.dev.appRegUri ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "env-row" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "env-key" },
                                                  [_vm._v("ID")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "env-value mono",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.dev.clientId || "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "env-row" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "env-key" },
                                                  [_vm._v("SP")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "env-value mono",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.dev
                                                          .servicePrincipalId ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            item.dev.lookupError
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "env-row env-row--chip",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "env-key",
                                                      },
                                                      [_vm._v("Issue")]
                                                    ),
                                                    _c(
                                                      "v-chip",
                                                      {
                                                        staticClass: "env-chip",
                                                        attrs: {
                                                          "x-small": "",
                                                          color: "#ffebee",
                                                          "text-color":
                                                            "#b71c1c",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.dev
                                                                .lookupError
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.qas`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-caption env-cell",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "env-row" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "env-key" },
                                                  [_vm._v("URI")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "env-value mono",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.qas.appRegUri ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "env-row" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "env-key" },
                                                  [_vm._v("ID")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "env-value mono",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.qas.clientId || "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "env-row" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "env-key" },
                                                  [_vm._v("SP")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "env-value mono",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.qas
                                                          .servicePrincipalId ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            item.qas.lookupError
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "env-row env-row--chip",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "env-key",
                                                      },
                                                      [_vm._v("Issue")]
                                                    ),
                                                    _c(
                                                      "v-chip",
                                                      {
                                                        staticClass: "env-chip",
                                                        attrs: {
                                                          "x-small": "",
                                                          color: "#ffebee",
                                                          "text-color":
                                                            "#b71c1c",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.qas
                                                                .lookupError
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.prod`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-caption env-cell",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "env-row" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "env-key" },
                                                  [_vm._v("URI")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "env-value mono",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.prod.appRegUri ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "env-row" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "env-key" },
                                                  [_vm._v("ID")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "env-value mono",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.prod.clientId ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "env-row" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "env-key" },
                                                  [_vm._v("SP")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "env-value mono",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.prod
                                                          .servicePrincipalId ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            item.prod.lookupError
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "env-row env-row--chip",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "env-key",
                                                      },
                                                      [_vm._v("Issue")]
                                                    ),
                                                    _c(
                                                      "v-chip",
                                                      {
                                                        staticClass: "env-chip",
                                                        attrs: {
                                                          "x-small": "",
                                                          color: "#ffebee",
                                                          "text-color":
                                                            "#b71c1c",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.prod
                                                                .lookupError
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("template", { slot: "no-data" }, [
                                _vm.loading
                                  ? _c("div", [_vm._v("Loading entries ...")])
                                  : _c("div", [_vm._v("No entries found.")]),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "820" },
          model: {
            value: _vm.statsDialog,
            callback: function ($$v) {
              _vm.statsDialog = $$v
            },
            expression: "statsDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("SMT Admin Consent Stats"),
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                        _c("div", { staticClass: "stats-title" }, [
                          _vm._v("Proxy"),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "Proxies total: " +
                              _vm._s(_vm.stats.proxy.proxiesTotal)
                          ),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "Proxies with endpoint used: " +
                              _vm._s(_vm.stats.proxy.proxiesWithEndpointUsed)
                          ),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "Proxy URIs total: " +
                              _vm._s(_vm.stats.proxy.proxyUrisTotal)
                          ),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "Proxy URIs unique: " +
                              _vm._s(_vm.stats.proxy.proxyUrisUnique)
                          ),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "Mapped unique: " +
                              _vm._s(_vm.stats.proxy.proxyUrisMappedUnique)
                          ),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "Unmapped unique: " +
                              _vm._s(_vm.stats.proxy.proxyUrisUnmappedUnique)
                          ),
                        ]),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                        _c("div", { staticClass: "stats-title" }, [
                          _vm._v("Service Principal"),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "Pages fetched: " +
                              _vm._s(_vm.stats.servicePrincipal.pagesFetched)
                          ),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "SP fetched: " +
                              _vm._s(
                                _vm.stats.servicePrincipal
                                  .servicePrincipalsFetched
                              )
                          ),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "SP URIs total: " +
                              _vm._s(
                                _vm.stats.servicePrincipal
                                  .servicePrincipalUrisTotal
                              )
                          ),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "SP URIs unique: " +
                              _vm._s(
                                _vm.stats.servicePrincipal
                                  .servicePrincipalUrisUnique
                              )
                          ),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "SP URIs used unique: " +
                              _vm._s(
                                _vm.stats.servicePrincipal
                                  .servicePrincipalUrisUsedUnique
                              )
                          ),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "SP URIs unused unique: " +
                              _vm._s(
                                _vm.stats.servicePrincipal
                                  .servicePrincipalUrisUnusedUnique
                              )
                          ),
                        ]),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                        _c("div", { staticClass: "stats-title" }, [
                          _vm._v("Mapping"),
                        ]),
                        _c("div", { staticClass: "stats-line" }, [
                          _vm._v(
                            "Coverage: " +
                              _vm._s(
                                _vm.formatCoverage(
                                  _vm.stats.mapping.coveragePercent
                                )
                              ) +
                              "%"
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "#006c27" },
                      on: {
                        click: function ($event) {
                          _vm.statsDialog = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackbar.color, timeout: "3000" },
          model: {
            value: _vm.snackbar.visible,
            callback: function ($$v) {
              _vm.$set(_vm.snackbar, "visible", $$v)
            },
            expression: "snackbar.visible",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackbar.text) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }